var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatlab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 16.803,
    y1: 16.631,
    x2: 15.013,
    y2: 22.411,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#29d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 29.71,
    y1: 18.983,
    x2: 11.71,
    y2: 14.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#de5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#f06e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#fa8042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fe8643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fa7f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#ef6c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#dc4c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#cf3633"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_matlab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2,17.55l7.97-3.22a20.7,20.7,0,0,1,2.72-2.95c.66-.35,1.9-.16,4.17-2.98,2.2-2.75,2.9-5.1,3.93-5.1,1.63,0,2.83,3.52,4.65,8.85A115.629,115.629,0,0,0,30,24.12c-1.9-1.77-3.52-3.68-5.37-3.63-1.72.04-3.63,2.08-5.72,4.7-1.66,2.1-3.86,3.54-4.72,3.51,0,0-2.22-6.28-4.08-7.3a2.641,2.641,0,0,0-2.39.2L2,17.54Z",
    style: {
      fill: "#49d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,4.02c-.67.9-1.48,2.55-2.94,4.38-2.27,2.82-3.5,2.63-4.17,2.98a19.674,19.674,0,0,0-2.72,2.95l3.3,2.41c2.8-3.82,4.3-7.96,5.47-10.64A13.579,13.579,0,0,1,19.8,4.02Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8,3.3c-2.18,0-3.67,11.48-11.72,17.89,2.26-.37,4.22,5.24,5.12,7.51,4-.68,7.2-8.33,10.43-8.21,1.85.07,3.47,1.86,5.37,3.63C25.66,15,23.63,3.3,20.8,3.3Z",
    style: {
      fill: "url(#b)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatlab);
export default __webpack_public_path__ + "static/media/matlab.b8ad8ae65efed3581418cc137e4e49c7.svg";
export { ForwardRef as ReactComponent };